// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","card":"PalletConfigurationCard_card__OPfp-","cardContent":"PalletConfigurationCard_cardContent__vEOsC"};